import ModalFrameHoc from 'components/Modal/modalFrameHoc'
import PropTypes from 'prop-types'
import React from 'react'
import styles from 'modules/Stories/Stories.module.scss'
import { Stories } from 'modules/Stories'

const StoriesModal = ({ startIndex = 0, closeModal, sendEvent, ...props }) => {
  return (
    <ModalFrameHoc
      {...props}
      showCloseButton={false}
      noHeader
      closeModal={closeModal}
      className={styles['stories__modal']}
    >
      <Stories
        startIndex={startIndex}
        closeModal={closeModal}
        sendEvent={sendEvent}
      />
    </ModalFrameHoc>
  )
}

export default StoriesModal

StoriesModal.propTypes = {
  buttons: PropTypes.object,
  closeModal: PropTypes.func,
  storiesData: PropTypes.array,
  startIndex: PropTypes.number,
  sendEvent: PropTypes.func,
}
